import { useClientTranslation } from '@/lib/core/i18n';
import { Icon } from '@/components/ui/icon';

export function ShopProductListEmpty() {
  const t = useClientTranslation();

  return (
    <div className="flex flex-col items-center gap-2 px-4 pt-16 text-center">
      <Icon name="shopping-bag" width={24} height={24} className="text-jncquoi-neutral-1000" />
      <p className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-[12px] tracking-[0.5px] uppercase">
        {t('App.Shop.NoProductsFound')}
      </p>
      <p className="font-pp-neue-montreal text-jncquoi-neutral-700 text-[14px] tracking-[0.5px]">
        {t('App.Shop.NoProductsFoundSub')}
      </p>
    </div>
  );
}
